import React from 'react';
import { connect } from 'react-redux'

import Master from '../../Components/Master';
import Dialog from '../../Components/Dialog';
import { TextFieldHelper } from '../../Components/Fields';
import { doPost } from '../../Redux/Actions'
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

import DatePickerContainer from '../../Components/DatePickerContainer';

const ENDPOINT = "parameter"

export const Fields = ({handleChange, name, key_val, value, valid}) => (
    <Grid container spacing={8}>

        <TextFieldHelper n={6} value={name} onChange={handleChange('name')} label="Name" />
        <Grid item xs={6}>
                                <DatePickerContainer
                                    dateInput
                                    name="von"
                                    label="Gültig von"
                                    value={valid}
                                    onChange={handleChange('valid')}
                                />
        </Grid>
        <Grid item xs={12}><Divider /></Grid>
        <TextFieldHelper disabled={true} n={6} value={key_val} onChange={handleChange('key_val')} label="Key" />
        <TextFieldHelper n={6} value={value} onChange={handleChange('value')} label="Value" />

    </Grid>
)

class NewEntry extends Master {

	state = {
		newEntry: {}
	}

	render() {

		var {
			handleClickOpen, dialogOpen
		} = this.props

        var {
        	newEntry
        } = this.state

		return (
			<Dialog
                title="Neuer Parameter"
                saveAction={this.postData}
                closeAction={handleClickOpen}
                open={dialogOpen}
             >
				<Fields handleChange={this.handleChange} {...newEntry} />
			</Dialog>
		)
	}

}

const mapStateToProps = state => ({
    [ENDPOINT]: state[ENDPOINT],
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    doPost: (data) => dispatch(doPost(ENDPOINT, "api/generic/" + ENDPOINT, data)),
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewEntry);


// WEBPACK FOOTER //
// ./src/Routes/Parameter/NewEntry.js